// Generated by ts-to-zod
import { z } from 'zod';

export const surveysListQuerySchema = z.object({
  pageSize: z.number().optional(),
  templateUuid: z.string().optional(),
  ordering: z.array(z.string()).optional(),
});
